import {
    areWeInStorybook,
    areWeTestingWithJest,
    baseLoggerConfig,
    isDevEnv,
    isProductionEnvironment,
    Logger,
} from "@buildwithflux/shared";
import pino from "pino";

const baseSettings: pino.LoggerOptions = {
    ...baseLoggerConfig,
    browser: {
        asObjectBindingsOnly: true,
    },
};

export function createPinoLoggerForEnvironment(): Logger {
    if (!process.env.DEBUG && (areWeTestingWithJest() || areWeInStorybook())) {
        return pino({...baseSettings, level: "silent"});
    }

    if (isDevEnv()) {
        return pino({
            ...baseSettings,
            level: "trace",
        });
    }

    if (isProductionEnvironment()) {
        return pino({
            ...baseSettings,
            level: "info",
        });
    }

    return pino({
        ...baseSettings,
        level: "debug",
    });
}
